<app-ce-review-task-content [task]="clientConsultNoteTask" />
